function ImportSignInGate({ onSignIn }) {
  return (
    <div style={{background:"#060e1b",borderRadius:14,border:"2px dashed #1e293b",padding:"36px 20px",textAlign:"center",marginTop:8}}>
      <div style={{fontSize:36,marginBottom:12}}>🔒</div>
      <div style={{fontSize:14,fontWeight:700,color:"#94a3b8",marginBottom:8}}>Sign in to import slips</div>
      <div style={{fontSize:12,color:"#334155",lineHeight:1.6,marginBottom:20}}>Sign in to import your slips and start tracking</div>
      <button onClick={onSignIn} style={{width:"100%",padding:"14px",background:"linear-gradient(135deg,#1d4ed8,#4f46e5)",border:"none",borderRadius:10,color:"#fff",fontSize:14,fontWeight:800,cursor:"pointer",fontFamily:"inherit"}}>
        Sign in with Google
      </button>
    </div>
  );
}

export default ImportSignInGate;
